<template>
    <div :class="css.not" class="container text-hint" v-if="!exist">{{ $t("Placeholder.UncollectedData") }}</div>
    <div v-else v-loading="loading" :class="css.container" class="container" ref="container">
        <ui-table2 :class="css.body" :option="option" :error="$t('NoDataAvailable')" :data="data" @sort="methods.sort">
            <template #number="{ data }">
                {{ (page - 1) * 10 + data.number }}
            </template>

            <!-- * 基因名称 or 疾病名称 -->
            <template #name="{ data }">
                <project-route :class="css_normalize.assets" :to="{ name: mode == 'gene' ? 'Gene' : 'Disease', params: { id: data.id } }">
                    {{ data.name }}
                </project-route>
            </template>

            <!-- * 功能 -->
            <template #function_extra>
                <!-- * 全选按钮 -->
                <ui-checkbox v-model="classification" :class="css_normalize.checkbox" value="all" @change="methods.classification">
                    {{ $t("SelectAll") }}
                </ui-checkbox>
                <!-- * 多选列表 -->
                <ui-checkbox-group v-model="classifications" @change="methods.classifications" :class="css.checkbox_group">
                    <template v-for="value in filters">
                        <ui-checkbox :class="css_normalize.checkbox" :value="value.value" :disabled="value.count == 0"
                            >{{ value.label }} ({{ value.count }})</ui-checkbox
                        >
                    </template>
                </ui-checkbox-group>
            </template>

            <!-- * 器官图标 -->
            <template #organ="{ data }">
                <div :class="css.organs">
                    <template v-for="value in data.organ">
                        <ui-tooltip-follow :class-extra-name="css.view" direction="bottom">
                            <img :class="css.organ" :src="value.icon" />
                            <template #content>
                                {{ value.name }}
                            </template>
                        </ui-tooltip-follow>
                    </template>
                </div>
            </template>

            <!-- * 突变数量 -->
            <template #mutation_number="{ data }">
                <template v-if="data.search_number == 0">{{ data.search_number }}</template>
                <ProjectRoute
                    :to="{ name: 'BioVariant', query: methods.route(data.id) }"
                    v-else
                    :class="css_normalize.assets"
                    style="user-select: none">
                    {{ data.search_number }}
                </ProjectRoute>
            </template>
        </ui-table2>

        <ui-pagination :class="css.footer" v-model="page" :count="count" @change="methods.acquire()">
            <template #items> {{ $t("Layout.PaginationDetails", { count: count, limit: 10 }) }}</template>
        </ui-pagination>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTable2, UiPagination, UiCheckbox, UiCheckboxGroup, UiTooltipFollow } from "various-ui";

//* 组件属性
import { ModulePropsOption } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";

//* vue插件
const router = useRouter();
const id = router.currentRoute.value?.params?.id || "";

//* 组件属性注册
const define = defineProps(ModulePropsOption);

//* 组合函数
const { refs, nodes, methods, computeds } = useComposable(define);
const { exist, loading, count, page, data, classifications, classification, filters } = refs;
const { container } = nodes;
const { option } = computeds;

//* 组件挂载时获取数据
onMounted(() => methods.acquire(1, true));
</script>
